function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { deepClone } from '@bydesign-ui/utils';
export var MemCache = function () {
  function MemCache(direct) {
    _classCallCheck(this, MemCache);

    this.cache = {};
    this.direct = !!direct;
  }

  _createClass(MemCache, [{
    key: "addCache",
    value: function addCache(key, value) {
      if (this.direct) {
        this.cache[key] = value;
        return;
      }

      this.cache[key] = deepClone(value);
    }
  }, {
    key: "removeCache",
    value: function removeCache(key) {
      if (key == null) {
        var all = this.cache;
        this.cache = {};
        return all;
      }

      var res = this.cache[key];
      delete this.cache[key];
      return res;
    }
  }, {
    key: "getCache",
    value: function getCache(key) {
      var res = key != null ? this.cache[key] : this.cache;

      if (this.direct) {
        return res;
      }

      return deepClone(res);
    }
  }, {
    key: "hasKey",
    value: function hasKey(key) {
      return key in this.cache;
    }
  }]);

  return MemCache;
}();